import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Redirect non-admin users without an organization to the join page
  if (user.role !== 'admin' && !user.organizationId && location.pathname !== '/join-organization') {
    return <Navigate to="/join-organization" />;
  }

  // If user is on join page but already has an org, redirect to home
  if (user.organizationId && location.pathname === '/join-organization') {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 